// =============================================================================
// BCB · client da API de PTAX
// =============================================================================
// Chamamos um serverless proxy nosso (/api/ptax) em vez de bater
// diretamente no endpoint do Olinda/BCB, pra evitar CORS no browser
// (alguns endpoints do BCB nao mandam Access-Control-Allow-Origin).
//
// O proxy faz a chamada real e ainda valida o JWT do Supabase (mesma
// auth do /api/cnpj), entao so usuario com app_access consegue chamar.
// =============================================================================

import { supabase } from './supabase';

/**
 * Busca a PTAX (cotacao de COMPRA) do dolar pra uma data especifica.
 * Se a data cair em fim de semana ou feriado, o proxy retorna a do
 * ultimo dia util anterior dentro de uma janela de 10 dias.
 *
 * Retorna { rate, dateUsed, source } ou null em qualquer erro.
 */
export async function fetchPtaxCompra(isoDate) {
  if (!isoDate || typeof isoDate !== 'string') return null;
  try {
    const { data: sess } = await supabase.auth.getSession();
    const token = sess?.session?.access_token;
    if (!token) return null;

    const r = await fetch(`/api/ptax?date=${encodeURIComponent(isoDate)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) {
      // 404 (sem cotacao na janela), 401/403 (auth), 500/502 (erro proxy)
      const body = await r.json().catch(() => null);
      console.warn('[bcb] /api/ptax falhou:', r.status, body);
      return null;
    }
    const data = await r.json();
    if (!data?.ok || !Number.isFinite(Number(data.rate))) return null;
    return {
      rate: Number(data.rate),
      dateUsed: data.dateUsed,
      source: data.source,
    };
  } catch (e) {
    console.warn('[bcb] erro de rede:', e);
    return null;
  }
}
